/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderLightDto } from './ProviderLightDto';
import {
    ProviderLightDtoFromJSON,
    ProviderLightDtoFromJSONTyped,
    ProviderLightDtoToJSON,
    ProviderLightDtoToJSONTyped,
} from './ProviderLightDto';

/**
 * 
 * @export
 * @interface GetPrescriptionFiltersResponseDto
 */
export interface GetPrescriptionFiltersResponseDto {
    /**
     * Statuses
     * @type {Array<string>}
     * @memberof GetPrescriptionFiltersResponseDto
     */
    statuses: Array<GetPrescriptionFiltersResponseDtoStatusesEnum>;
    /**
     * Providers
     * @type {Array<ProviderLightDto>}
     * @memberof GetPrescriptionFiltersResponseDto
     */
    providers: Array<ProviderLightDto>;
}


/**
 * @export
 */
export const GetPrescriptionFiltersResponseDtoStatusesEnum = {
    Cancelled: 'cancelled',
    Paid: 'paid',
    Pending: 'pending'
} as const;
export type GetPrescriptionFiltersResponseDtoStatusesEnum = typeof GetPrescriptionFiltersResponseDtoStatusesEnum[keyof typeof GetPrescriptionFiltersResponseDtoStatusesEnum];


/**
 * Check if a given object implements the GetPrescriptionFiltersResponseDto interface.
 */
export function instanceOfGetPrescriptionFiltersResponseDto(value: object): value is GetPrescriptionFiltersResponseDto {
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    if (!('providers' in value) || value['providers'] === undefined) return false;
    return true;
}

export function GetPrescriptionFiltersResponseDtoFromJSON(json: any): GetPrescriptionFiltersResponseDto {
    return GetPrescriptionFiltersResponseDtoFromJSONTyped(json, false);
}

export function GetPrescriptionFiltersResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPrescriptionFiltersResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': json['statuses'],
        'providers': ((json['providers'] as Array<any>).map(ProviderLightDtoFromJSON)),
    };
}

export function GetPrescriptionFiltersResponseDtoToJSON(json: any): GetPrescriptionFiltersResponseDto {
    return GetPrescriptionFiltersResponseDtoToJSONTyped(json, false);
}

export function GetPrescriptionFiltersResponseDtoToJSONTyped(value?: GetPrescriptionFiltersResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statuses': value['statuses'],
        'providers': ((value['providers'] as Array<any>).map(ProviderLightDtoToJSON)),
    };
}

